import { Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import LinkableItemList from "~/modules/mapEditor/components/LinkableItemList";
import { ObservationCard } from "~/modules/mapEditor/components/ObservationCard";
import { ObservationCardFragment } from "~/modules/mapEditor/components/ObservationCard/fragments.generated";

type Props = {
    createTo: (element: ObservationCardFragment) => string;
    observations: ObservationCardFragment[];
    onLinkEcologicalFunctionWithObservationClick: (observationId: string) => Promise<void>;
    loading?: boolean;
};

export function LinkableObservationsList({
    createTo,
    observations,
    onLinkEcologicalFunctionWithObservationClick,
    loading,
}: Props) {
    const { t } = useTranslation("mapEditor");

    return observations.length > 0 ? (
        <>
            <Divider>{t("observationLinking.dividerTitle")}</Divider>
            <LinkableItemList
                clickable
                createTo={createTo}
                items={observations}
                renderCard={observation => (
                    <ObservationCard
                        disabled={loading}
                        isLinked={false}
                        observation={observation}
                        onLinkClick={onLinkEcologicalFunctionWithObservationClick}
                    />
                )}
            />
        </>
    ) : (
        <Typography paddingBlock={2}>{t("observationLinking.noLinkableObservations")}</Typography>
    );
}
